import React, {Component, useState} from 'react';
import {Link, Route, Routes} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faBuilding, faBars } from '@fortawesome/free-solid-svg-icons'
import { faPlug } from '@fortawesome/free-solid-svg-icons'
import { faSolarPanel } from '@fortawesome/free-solid-svg-icons'
import { faServer } from '@fortawesome/free-solid-svg-icons'
import { faBatteryFull, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'





export default function NavContent(){
    


        
        return (
            <ul class="navbar-nav  sidebar sidebar-dark accordion" id="accordionSidebar" style={{backgroundColor:"#000000", color:"#ffffff", height:"100%"}}>
    
            
            <a class="sidebar-brand d-flex align-items-center justify-content-center">
                <div class="sidebar-brand-icon rotate-n-15">
                <FontAwesomeIcon icon={faBolt} size="2x" /> 
                </div>
                <div class="sidebar-brand-text mx-3">TYDA Energy</div>
            </a>
        
            
           
            <hr class="sidebar-divider my-0"/>
        
         
            <li class="nav-item">
            <Link to="/dashboard" class="nav-link">
            <FontAwesomeIcon icon={faBuilding} size="lg" /> 
            
                    <span>{' '}{' '} Projects</span></Link>
            </li>
            <li class="nav-item">
            <Link to="/coming-soon" class="nav-link">
            <FontAwesomeIcon icon={faBolt} />
                    <span>{' '}{' '}Energy Monitoring</span></Link>
            </li>
        
            <li class="nav-item">
            <Link to="/items" class="nav-link">
            <FontAwesomeIcon icon={faPlug} />
                    <span>{' '}{' '}Items</span></Link>
            </li>
        
            <li class="nav-item">
            <Link to="/panels" class="nav-link">
            <FontAwesomeIcon icon={faSolarPanel} />
                    <span>{' '}{' '}Solar Panels</span></Link>
            </li>
        
        
            <li class="nav-item">
            <Link to="/coming-soon" class="nav-link">
            <FontAwesomeIcon icon={faBatteryFull} />
                    <span>{' '}{' '}Batteries</span></Link>
            </li>
        
            <li class="nav-item">
            <Link to="/coming-soon" class="nav-link">
            <FontAwesomeIcon icon={faServer} />
                    <span>{' '}{' '}Inverters</span></Link>
            </li>
          
            
        
        
            
        
         
        
        </ul>
            
         
        )
    }






  



